<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="poslovneJedinicaTable"
  ></kodit-table>
</kodit-page>
